require('./bootstrap');

$(document).ready(function() {
    $('.selectpicker').select2({
        width: '100%',
        templateSelection: function (data) {
            if (!data.element) {
                return data.text;
            }

            var $element = data.element;
            var $wrapper = $('<span></span>');
            $wrapper.addClass($element.className);
            $wrapper.text(data.text);

            return $wrapper;
        },
        templateResult: function (data) {
            if (!data.element) {
                return data.text;
            }

            var $element = data.element;
            var $wrapper = $('<option></option>');
            $wrapper.addClass($element.className);
            $wrapper.text(data.text);

            return $wrapper;
        }
    });

    $("#dropdown_project").change(function(){
        location.href = '/save-project/'+ $("#dropdown_project").val() +"/";

    });
    $("#dropdown_country").change(function(){
        location.href = '/save-country/'+ $("#dropdown_country").val() +"/";

    });
    $("#dropdown_change_crawl").change(function(){
        location.href = '/config/crawls/'+ $("#dropdown_project").val() +"/"+$("#dropdown_change_crawl").val();
    });
});
